import isBlank from '../utilities/isBlank';
import React from 'react';
import { FormattedMessage } from 'react-intl';

const validateExampleForm = (values) => {
  const { username, password } = values;

  return {
    username: isBlank(username),
    password: isBlank(password) ? <FormattedMessage id="hosting.validate_example_form.password_empty_message" defaultMessage="Please enter a password" /> : 8 > password.length && <FormattedMessage id="hosting.validate_example_form.password_length_message" defaultMessage="Password must be at least 8 characters" />
  };
};

export default validateExampleForm;
